import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../../config/siteConfig";
import classNames from "./classNames";

const BrandIcon = ({ title }) => (
  <svg
    className="brand-mark__icon"
    viewBox="0 0 64 64"
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title || undefined}
  >
    <circle cx="32" cy="32" r="28" fill="currentColor" />
    <path d="M18 46V18h7l7 12 7-12h7v28h-7V30l-7 11-7-11v16Z" fill="#f4e2c7" />
    <path d="M17 51c10-4 20-4 30 0" fill="none" stroke="#277e26" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const BrandMark = ({
  className,
  compact = false,
  inverse = false,
  linked = true,
  showTagline = false,
}) => {
  const brandName = siteConfig.brandName;
  const content = (
    <>
      <BrandIcon title={linked ? undefined : `${brandName} logo`} />
      {!compact && (
        <span className="brand-mark__copy">
          <span className="brand-mark__name" aria-label={brandName}>
            <span className="brand-mark__name-lead">m</span>ade<span className="brand-mark__name-turn">z</span>uno
          </span>
          {showTagline && siteConfig.tagline && (
            <span className="brand-mark__tagline">{siteConfig.tagline}</span>
          )}
        </span>
      )}
    </>
  );

  const classes = classNames(
    "brand-mark",
    compact && "brand-mark--compact",
    inverse && "brand-mark--inverse",
    className
  );

  if (!linked) {
    return <span className={classes}>{content}</span>;
  }

  return (
    <Link className={classes} to="/" aria-label={`${brandName} home`}>
      {content}
    </Link>
  );
};

export default BrandMark;
